import ArrayStore from "devextreme/data/array_store";
import { RoamBinMovementsService } from "../../_services/api/roam/bin/roam-bin-movement.service";

export const roamBinMovement = {
  namespaced: true,
  state: {
    dataSource: new ArrayStore({
      key: "BarCode",
      data: [],
    }),
  },
  actions: {
    insertItem({ commit }, message) {
      commit("insertItem", message)
    },
    updateItem({ commit }, message) {
      commit("updateItem", message)
    },
    removeItem({ commit }, message) {
      commit("removeItem", message)
    },
    clearStore({ commit }) {
      commit("clearStore");
    },
    processQueuedRequests({ state, commit }, message) {
      // Check network availability
      const isOnline = navigator.onLine;

      if (isOnline) {
        let queItems = state.dataSource._array.filter(
          (x) => x.Status == "Queued"
        );

        if (queItems.length > 0) {
          queItems.forEach((element) => {
            commit("updateItem", {
              BarCode: element.BarCode,
              Status: "Pending",
            })
            RoamBinMovementsService.getByBarCode(element.BarCode)
              .then((res) => {
                let data = res.data;
                state.dataSource.byKey(element.BarCode).then((item) => {
                  RoamBinMovementsService.saveNew({
                    BinCardNo: data.CardNumber,
                    SeasonCode: data.SeasonYear,
                    LocationID: item.LocationID,
                  })
                    .then(() => {
                      commit("updateItem", {
                        Bin: data.CardNumber,
                        Variety: data.ProdCat1,
                        BarCode: element.BarCode,
                        Status: "Completed",
                      });
                      message();

                    })
                    .catch((err) => {
                      if (err && err.status == 400) {
                        message({
                          type: 'server',
                          err: err
                        });
                      } else {
                        commit("updateItem", {
                          BarCode: element.BarCode,
                          Status: "Queued",
                        })
                      }
                    });
                });
              })
              .catch(async (err) => {
                if (err) {
                  if (err && err.status == 400) {
                    commit("updateItem", {
                      BarCode: element.BarCode,
                      Status: "Invalid",
                    });
                    message({
                      type: 'local',
                      err: "Invalid Barcode"
                    });
                  } else {
                    commit("updateItem", {
                      BarCode: element.BarCode,
                      Status: "Queued",
                    })
                  }
                }
              });
          });
        }
      }
    },
  },
  mutations: {
    insertItem(state, item) {
      // state.dataSource.insert(item);
      // state.dataSource.push([{ type: 'insert', data: item, index: 0 }]);

      state.dataSource._array.unshift(item);
    },
    updateItem(state, item) {
      // state.dataSource.update(item.BarCode, item);
      state.dataSource.push([{ type: "update", data: item, key: item.BarCode }]);
    },
    removeItem(state, item) {
      state.dataSource.remove(item.BarCode);
    },
    clearStore(state) {
      state.dataSource.clear();
    }
  },
  getters: {
    getDataSource(state) {
      return state.dataSource;
    },
    getDataLength(state) {
      return state.dataSource._array.length;
    }
  },
};
